import React, { useEffect, useRef } from "react";
import Layout from "../components/layouts/Layout";
import { useState } from "react";
import { GetTicketList } from "../services/TicketService";
import { Pagination } from "@nextui-org/pagination";
import useTicketStore from "../stores/useTicketStore";
import AppUserProfile, { UserType } from "../assets/js/AppUserProfile";
import DealerTicketTile from "../components/ticketDetail/DealerTicketTile";
import ApproverTicketTile from "../components/ticketDetail/ApproverTicketTile";
import useApproverStore from "../stores/useApproverStore";
import FilterBar from "../components/layouts/filters/FilterBar";
import { useQueryParams } from "../hooks/useQueryParams";
import { AnnoucementContainer } from "../components/layouts/NavBar";
import { annoucements } from "../constants/annoucement";

const TicketListPage = () => {
  const [tickets, setTickets] = useState({ tickets: [], pagination: {} });
  const [isLoading, setIsLoading] = useState(true);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const userRole = AppUserProfile.getData()["whoami"];
  const loadTicketTimeoutRef = useRef(null);

  const { approvers, fetchApprovers } = useApproverStore();
  const queryParams = useQueryParams();

  const {
    pagination,
    setPagination,
    handlePageChange,
    getFilterParams,
    activeFilters,
    formatOtherFilter,
    findTicketId,
    selectedMenu,
    selectedPhase,
    selectedStatus,
    selectedSort,
    otherFilter,
  } = useTicketStore();

  const handlePageChangeClick = (page) => {
    handlePageChange(page, queryParams);
  };

  const loadTicket = async () => {
    try {
      setIsLoading(true);

      const filterParams = getFilterParams();

      const data = await GetTicketList({ bodyPayload: filterParams });
      if (data?.status != 200) {
        return;
      }

      const filteredTickets = data.data.tickets.filter(
        (ticket) => ticket.status !== "CANCELLED"
      );

      const sortedTickets = [...filteredTickets].map((ticket) => ({
        ...ticket,
        sub_tickets: [...ticket.sub_tickets].sort((a, b) => a.id - b.id),
      }));

      setTickets({ tickets: sortedTickets, pagination: data.data.pagination });
      setPagination(data.data.pagination, queryParams);
    } finally {
      setIsLoading(false);
      setIsInitialLoad(false);
    }
  };

  useEffect(() => {
    if (!approvers || approvers.size === 0) {
      fetchApprovers();
    }
  }, [approvers, fetchApprovers]);

  useEffect(() => {
    if (loadTicketTimeoutRef.current) {
      clearTimeout(loadTicketTimeoutRef.current);
    }

    loadTicketTimeoutRef.current = setTimeout(() => {
      loadTicket();
    }, 300);

    return () => {
      if (loadTicketTimeoutRef.current) {
        clearTimeout(loadTicketTimeoutRef.current);
      }
    };
  }, [
    activeFilters,
    formatOtherFilter,
    findTicketId,
    pagination.page_id,
    selectedMenu,
    selectedPhase,
    selectedStatus,
    selectedSort,
    otherFilter,
  ]);

  return (
    <Layout>
      <div className="flex-col">
        <div className="flex-1 flex justify-center min-w-0 ">
          <div className="w-full pt-5 px-10">
            <AnnoucementContainer annoucement={annoucements.documentDueDate} />
          </div>
        </div>
        <div className="py-5 flex">
          <FilterBar />
        </div>

        {isLoading && isInitialLoad ? (
          <div className="flex items-center justify-center min-h-64">
            <div className="text-center">
              <p>กำลังโหลด</p>
            </div>
          </div>
        ) : tickets.tickets.length ? (
          <>
            <div className="flex flex-col gap-y-6 px-8">
              {tickets.tickets.map((ticket) => {
                return (
                  <div key={ticket.id + ticket.status} className="">
                    {userRole === UserType.DEALER_BYD ||
                    userRole === UserType.DEALER_DENZA ? (
                      <DealerTicketTile
                        ticketData={ticket}
                        reFetch={loadTicket}
                      />
                    ) : (
                      <ApproverTicketTile ticketData={ticket} />
                    )}
                  </div>
                );
              })}
            </div>

            {tickets.pagination && tickets.pagination.last_page > 1 && (
              <div className="flex justify-center py-5">
                <Pagination
                  initialPage={1}
                  page={pagination.page_id}
                  total={tickets.pagination.last_page}
                  classNames={{
                    item: "w-8 h-8 text-small rounded-xl bg-transparent border-transparent",
                    cursor: "bg-black text-white font-bold",
                  }}
                  onChange={handlePageChangeClick}
                />
              </div>
            )}
          </>
        ) : (
          <div className="flex items-center justify-center min-h-64">
            <div className="text-center">
              <p className="text-gray-500 text-lg">ไม่พบคำขอ</p>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default TicketListPage;
